import { Checkbox, Typography } from '@material-ui/core'
import { Field } from 'formik'
import { Container } from './FormikCheckbox.style'

interface FormikCheckboxProps {
  name: string
  checked?: boolean
  disabled?: boolean
  onChange: () => any
  text: string
}

const FormikCheckbox = ({
  name,
  checked,
  disabled,
  onChange,
  text,
  ...props
}: FormikCheckboxProps) => {
  return (
    <Container {...props}>
      <Field
        type="checkbox"
        color="primary"
        name={name}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        component={Checkbox}
      />
      <Typography color={disabled ? 'secondary' : 'initial'}>{text}</Typography>
    </Container>
  )
}

export default FormikCheckbox
